import { ConfigurationRegistry } from '../services';
import { Registry } from '@workbench-stack/platform';
import { Extensions } from '../constants';

const configurationRegistry = new ConfigurationRegistry();
Registry.Instance.add(Extensions.Configuration, configurationRegistry);
